<!-- Overlay backdrop -->
<div class="mobile-menu__backdrop" (click)="onBackdropClick()" aria-hidden="true"></div>

<!-- Slide-in panel -->
<aside
  class="mobile-menu__panel"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="translationService.translate('accessibility.navigation_menu')"
  (click)="onPanelClick($event)"
>
  <!-- Header with close button -->
  <div class="mobile-menu__header">
    <button
      class="mobile-menu__close"
      (click)="closeMenu.emit()"
      [attr.aria-label]="translationService.translate('accessibility.close_menu')"
    >
      <rt-icon name="close" />
    </button>
  </div>

  <!-- Navigation section -->
  <nav class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ translationService.translate('mobile_menu.navigation') }}
    </h3>
    <ul class="mobile-menu__nav-list">
      @for (item of mainNavItems; track item) {
        <li>
          <button
            class="mobile-menu__nav-item"
            [class.mobile-menu__nav-item--active]="activeMainTab() === item"
            (click)="onMainTabClick(item)"
          >
            {{ getMainNavLabel(item) }}
            @if (activeMainTab() === item) {
              <span class="mobile-menu__nav-indicator"></span>
            }
          </button>
        </li>
      }
    </ul>
  </nav>

  <!-- Product filters section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ translationService.translate('mobile_menu.filter_by_product') }}
    </h3>
    <div class="mobile-menu__chips">
      @for (tab of productTabs; track tab) {
        <button
          class="mobile-menu__chip"
          [class.mobile-menu__chip--active]="activeProductTab() === tab"
          (click)="onProductTabClick(tab)"
        >
          {{ getProductTabLabel(tab) }}
        </button>
      }
    </div>
  </div>

  <!-- Settings section -->
  <div class="mobile-menu__section">
    <h3 class="mobile-menu__section-title">
      {{ translationService.translate('mobile_menu.settings') }}
    </h3>

    <!-- Language selector -->
    <div class="mobile-menu__setting">
      <label class="mobile-menu__setting-label" for="mobile-language-select">
        {{ translationService.translate('mobile_menu.language') }}
      </label>
      <select
        id="mobile-language-select"
        class="mobile-menu__select"
        [value]="currentLocale()"
        (change)="onLocaleChange($event)"
      >
        @for (locale of availableLocales(); track locale) {
          <option [value]="locale" [attr.selected]="currentLocale() === locale ? '' : null">
            {{ getLanguageLabel(locale) }}
          </option>
        }
      </select>
    </div>

    <!-- Theme toggle -->
    <div class="mobile-menu__setting">
      <span class="mobile-menu__setting-label">{{
        translationService.translate('mobile_menu.theme')
      }}</span>
      <button class="mobile-menu__theme-toggle" (click)="onThemeToggle()">
        <rt-icon [name]="isDarkMode() ? 'dark' : 'light'" />
        <span>{{
          isDarkMode()
            ? translationService.translate('mobile_menu.dark')
            : translationService.translate('mobile_menu.light')
        }}</span>
      </button>
    </div>
  </div>

  <!-- Feedback link -->
  <div class="mobile-menu__footer">
    <rt-button variant="outline" size="medium" class="mobile-menu__feedback">
      {{ translationService.translate('header.give_feedback') }}
    </rt-button>
  </div>
</aside>
